import {StringUtils} from '../../utils/string.utils';
import {ApiJsonResult} from '../../utils/api/apijsonresult';
import {ActivityMaster} from './ActivityMaster';
import {ScopeProfileMaster} from './ScopeProfileMaster';

export class ScopeActivityTrackerInProgress {

    id: number;
    childId: number;
    activityMasterId: number;
    activity: string;
    activityMaster: ActivityMaster;
    response: string;
    byParent: string;
    byTherapist: string;
    scopeProfileMasterId: number;
    scopeProfileMaster: ScopeProfileMaster;
    childProgressLevelTrackerId: number;
    noLogs: number;
    createdBy: string;
    createdDate: any;
    updatedBy: string;
    updatedDate: any;

    static populate(jsonObject: any): ScopeActivityTrackerInProgress {
        const obj = new ScopeActivityTrackerInProgress();
        obj.id = jsonObject.id;
        obj.childId = jsonObject.childId;
        obj.activityMasterId = jsonObject.activityMasterId;
        obj.activityMaster = jsonObject.activityMaster;
        obj.activity = jsonObject.activity;
        obj.response = jsonObject.response;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.scopeProfileMasterId = jsonObject.scopeProfileMasterId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.noLogs = jsonObject.noLogs;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static formPopulate(obj: ScopeActivityTrackerInProgress, jsonObject: any): ScopeActivityTrackerInProgress {
        if (obj == null) {
            obj = new ScopeActivityTrackerInProgress();
        }
        obj.id = jsonObject.id;
        obj.childId = jsonObject.childId;
        obj.activityMasterId = jsonObject.activityMasterId;
        obj.activity = jsonObject.activity;
        obj.response = jsonObject.response;
        obj.byParent = jsonObject.byParent;
        obj.byTherapist = jsonObject.byTherapist;
        obj.scopeProfileMasterId = jsonObject.scopeProfileMasterId;
        obj.childProgressLevelTrackerId = jsonObject.childProgressLevelTrackerId;
        obj.createdBy = jsonObject.createdBy;
        obj.createdDate = jsonObject.createdDate;
        obj.updatedBy = jsonObject.updatedBy;
        obj.updatedDate = jsonObject.updatedDate;
        return obj;
    }

    static apimapper(apijsonResult: ApiJsonResult): ScopeActivityTrackerInProgress {
        let obj = null;
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            obj = ScopeActivityTrackerInProgress.populate(jsonObject);
        }
        return obj;
    }

    static apimapperLst(apijsonResult: ApiJsonResult): ScopeActivityTrackerInProgress [] {
        const lst: ScopeActivityTrackerInProgress [] = [];
        if (!StringUtils.isEmpty(apijsonResult.outputjson)) {
            const jsonObject = JSON.parse(apijsonResult.outputjson);
            for (let i = 0; i < jsonObject.length; i++) {
                lst.push(ScopeActivityTrackerInProgress.populate(jsonObject[i]));
            }
            return lst;
        }
    }

}

